// The register lines the taxonomy's non-envelope rows speak in (VOICE's register, applied per
// CLAUDE.md until VOICE.md lands: calm, immediate, exact — the maison never performs). Envelope
// errors speak the API's own message; these two are the client's own words for failures the
// API never got a chance to describe.

export const OFFLINE_MESSAGE = "The connection dropped. Check it and try again.";

export const GENERIC_SERVER_MESSAGE = "Something went wrong. Try again in a moment.";
